/** Copyright (c) 2019 T. Rowe Price. All rights reserved. */
import { createLogic } from 'redux-logic';
import { RECEIVED_CMM_UPDATE_STOPMAIL } from 'state/contactMethodMaintenance/ContactMethodMaintenanceActions';
import { addToast } from 'state/toast/ToastActions';

const UpdateMailingAddressLogic = createLogic({
  type: RECEIVED_CMM_UPDATE_STOPMAIL,
  process({ action }, dispatch, done) {
    const { response } = action;
    console.log("response",response);
    if(response){
      console.log(" success response ",response);
    dispatch(addToast(true, 'Submission saved'));
    done();
    }
  }
});

export default UpdateMailingAddressLogic;
